<template>
<div v-if="brokersLoading">
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
  <div v-else>
    <v-dialog scrollable v-model="loading" persistent max-width="200">
      <v-card>
        <v-card-title>{{ $t("globals.please_wait") }}</v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="confirmDeactivateDialog"
      scrollable
      persistent
      max-width="400"
    >
      <material-card
        :title="
          selectedItem !== null && selectedItem !== undefined
            ? $t('views.users.deactivate_user_{0}', [selectedItem.Email])
            : $t('views.users.deactivate_users')
        "
        :color="$vuetify.theme.themes.light.error"
        icon="toggle_off"
      >
        <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
        <v-card-actions>
          <v-btn
            :disabled="saving"
            text
            @click="confirmDeactivateDialog = false"
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" :loading="saving" @click="deactivate">
            {{ $t("globals.deactivate") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      v-model="confirmActivateDialog"
      scrollable
      persistent
      max-width="400"
    >
      <material-card
        :title="
          selectedItem !== null && selectedItem !== undefined
            ? $t('views.users.activate_user_{0}', [selectedItem.Email])
            : $t('views.users.activate_users')
        "
        :color="$vuetify.theme.themes.light.success"
        icon="toggle_on"
      >
        <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
        <v-card-actions>
          <v-btn :disabled="saving" text @click="confirmActivateDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" :loading="saving" @click="activate">
            {{ $t("globals.activate") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      v-model="confirmDeleteDialog"
      scrollable
      persistent
      max-width="400"
    >
      <material-card
        v-if="selectedItem"
        :title="$t('views.users.delete_user_{0}', [selectedItem.Email])"
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
        <v-card-actions>
          <v-btn color text @click="confirmDeleteDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" @click="deleteItem">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      v-model="confirmResetPasswordDialog"
      scrollable
      persistent
      max-width="400"
    >
      <material-card
        v-if="selectedItem"
        :title="$t('views.users.reset_user_password_{0}', [selectedItem.Email])"
        :color="$vuetify.theme.themes.light.warning"
        icon="clear"
      >
        <v-card-text>{{ $t("globals.are_you_sure") }}</v-card-text>
        <v-card-actions>
          <v-btn
            color
            :disabled="saving"
            text
            @click="confirmResetPasswordDialog = false"
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" :loading="saving" @click="resetPassword">
            {{ $t("components.membersmanagementtable.reset_password") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog v-model="editDialog" scrollable persistent max-width="500px">
      <material-card
        v-if="editedItem"
        :title="formTitle"
        :color="formColor"
        :icon="formIcon"
      >
        <v-card-text>
          <v-form style="margin:20px" ref="form" v-model="valid">
            <v-row>
              <no-autocomplete-textfield
                v-model="editedItem.FirstName"
                :label="$t('globals.firstname')"
                :rules="[$rules.required, $rules.validName]"
                validate-on-blur
                class="required"
              ></no-autocomplete-textfield>
            </v-row>
            <v-row>
              <no-autocomplete-textfield
                v-model="editedItem.LastName"
                :label="$t('globals.lastname')"
                :rules="[$rules.required, $rules.validLastName]"
                validate-on-blur
                class="required"
              ></no-autocomplete-textfield>
            </v-row>
            <v-row>
              <auto-select
                :value.sync="editedItem.Broker"
                :items="brokers"
                :label="$t('globals.broker')"
                item-text="Name"
                item-value="Id"
                return-object
                disabled
              />
            </v-row>
            <v-row>
              <no-autocomplete-textfield
                :error-messages="emailErrorMessages"
                :error="emailError"
                ref="email"
                v-model="editedItem.Email"
                :rules="[$rules.required, $rules.email, rules.confirmEmail]"
                :label="$t('headers.contacts.email')"
                :disabled="editedIndex > -1"
                validate-on-blur
                class="required"
              ></no-autocomplete-textfield>
            </v-row>
            <v-row v-if="editedIndex === -1">
              <no-autocomplete-textfield
                :error-messages="emailErrorMessages"
                :error="emailError"
                ref="confirmEmail"
                v-model="confirmEmail"
                :rules="[$rules.required, $rules.email, rules.confirmEmail]"
                :label="$t('views.users.confirm_email')"
                class="required"
              ></no-autocomplete-textfield>
            </v-row>
            <v-row>
              <!--no-autocomplete-textfield
                  ref="password"
                  v-if="editedIndex == -1"
                  v-model="editedItem.Password"
                  :type="'password'"
                  :rules="passwordRules"
                  :label="$t('views.firstlogin.password')"
                  required
                  validate-on-blur
                ></no-autocomplete-textfield>
                <no-autocomplete-textfield
                  ref="confirmPassword"
                  v-if="editedIndex == -1"
                  v-model="editedItem.ConfirmPassword"
                  :type="'password'"
                  :rules="confirmPasswordRules"
                  :label="$t('views.firstlogin.password Confirmation')"
                  required
                  validate-on-blur
              ></no-autocomplete-textfield-->
              <v-autocomplete
                v-model="editedItemRoles"
                :items="roles"
                :label="$t('views.users.roles')"
                item-text="Name"
                item-value="Id"
                return-object
                multiple
                validate-on-blur
                :rules="[$rules.atLeastOneRole]"
              ></v-autocomplete>
            </v-row>
            <v-row
              v-if="
                editedItemRoles.filter(
                  (ur) =>
                    ur.Name === 'Employer Plan Admin' ||
                    ur.Name === 'Broker Plan Admin' ||
                    ur.Name === 'Broker Plan Manager' ||
                    ur.Name === 'Documents Management Admin' ||
                    ur.Name === 'Employer Members Viewer' ||
                    ur.Name === 'Employer Billing Viewer' ||
                    ur.Name === 'Employer Premiums Viewer' ||
                    ur.Name === 'Member Portal Admin' ||
                    ur.Name === 'Member Portal Users Admin'
                ).length > 0
              "
            >
              <v-autocomplete
                v-model="editedItemTags"
                :items="tags"
                :label="$t('components.vuematerialdashboard.core.appbar.tags')"
                item-text="Name"
                item-value="Id"
                return-object
                multiple
              ></v-autocomplete>
            </v-row>
            <v-row
              v-if="
                editedItemRoles.filter(
                  (ur) =>
                    ur.Name === 'Employer Plan Admin' ||
                    ur.Name === 'Broker Plan Admin' ||
                    ur.Name === 'Broker Plan Manager' ||
                    ur.Name === 'Documents Management Admin' ||
                    ur.Name === 'Employer Members Viewer' ||
                    ur.Name === 'Employer Billing Viewer' ||
                    ur.Name === 'Employer Premiums Viewer' ||
                    ur.Name === 'Member Portal Admin' ||
                    ur.Name === 'Member Portal Users Admin'
                ).length > 0
              "
            >
              <trans-multi-select2
                v-model="editedItemPlans"
                :items="plans"
                :label="$t('globals.plans')"
                :rules="[$rules.atLeastOne]"
                field="Name"
                itemValue="Id"
                :canSelectAll="true"
                class="required"
                validate-on-blur
              ></trans-multi-select2>
            </v-row>
            <v-row
              v-if="
                editedItemRoles.filter(
                  (ur) =>
                    ur.Name === 'Employer Plan Admin' ||
                    ur.Name === 'Employer Members Viewer' ||
                    ur.Name === 'Employer Billing Viewer' ||
                    ur.Name === 'Employer Premiums Viewer'
                ).length > 0
              "
            >
              <trans-multi-select2
                v-model="editedItemEmployers"
                :items="assignableEmployers"
                :label="$t('globals.employers')"
                field="Name"
                itemValue="Id"
                validate-on-blur
                :rules="[$rules.atLeastOne]"
              ></trans-multi-select2>
            </v-row>
            <v-row
              v-if="
                editedItemRoles.filter(
                  (ur) =>
                    ur.Name === 'Employer Plan Admin' ||
                    ur.Name === 'Employer Members Viewer' ||
                    ur.Name === 'Employer Billing Viewer' ||
                    ur.Name === 'Employer Premiums Viewer'
                ).length > 0
              "
            >
              <trans-multi-select2
                v-model="editedItemStores"
                :items="assignableStores"
                :label="$t('globals.stores')"
                field="Name"
                itemValue="Id"
                validate-on-blur
              ></trans-multi-select2>
            </v-row>
            <v-row>
              <v-checkbox
                v-model="editedItem.IsActive"
                :label="$t('globals.active')"
              ></v-checkbox>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="close">{{ $t("globals.cancel") }}</v-btn>
          <v-btn
            :disabled="!valid"
            color="primary"
            :loading="saving"
            @click="save"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      v-model="createTokenDialog"
      scrollable
      persistent
      max-width="500px"
    >
      <material-card
        :title="$t('views.users.create_new_token_for_user_registration')"
        :color="$vuetify.theme.themes.light.success"
        icon="vpn_key"
      >
        <v-card-text>
          <v-container fluid fill-height>
            <v-flex md12>
              <v-form ref="tokenform" v-model="tokenvalid">
                <auto-select
                  :value.sync="token.broker"
                  :items="brokers"
                  :label="$t('globals.broker')"
                  item-text="Name"
                  item-value="Id"
                  return-object
                  disabled
                  validate-on-blur
                />
                <no-autocomplete-textfield
                  :error-messages="emailErrorMessages"
                  :error="emailError"
                  ref="email"
                  v-model="token.email"
                  :rules="[$rules.required, $rules.email, rules.confirmTokenEmail]"
                  :label="$t('headers.contacts.email')"
                  class="required"
                  validate-on-blur
                ></no-autocomplete-textfield>
                <no-autocomplete-textfield
                  :error-messages="emailErrorMessages"
                  :error="emailError"
                  ref="email"
                  v-model="confirmEmail"
                  :rules="[$rules.required, $rules.email, rules.confirmTokenEmail]"
                  :label="$t('views.users.confirm_email')"
                  class="required"
                ></no-autocomplete-textfield>
                <v-autocomplete
                  v-model="editedItemRoles"
                  :items="roles"
                  :label="$t('views.users.roles')"
                  item-text="Name"
                  item-value="Id"
                  return-object
                  multiple
                  validate-on-blur
                  :rules="[$rules.atLeastOne]"
                ></v-autocomplete>
                <v-autocomplete
                  v-if="
                    editedItemRoles.filter(
                      (ur) =>
                        ur.Name === 'Employer Plan Admin' ||
                        ur.Name === 'Broker Plan Admin' ||
                        ur.Name === 'Broker Plan Manager' ||
                        ur.Name === 'Documents Management Admin' ||
                        ur.Name === 'Employer Members Viewer' ||
                        ur.Name === 'Employer Billing Viewer' ||
                        ur.Name === 'Employer Premiums Viewer' ||
                    ur.Name === 'Member Portal Admin' ||
                    ur.Name === 'Member Portal Users Admin'
                    ).length > 0
                  "
                  v-model="editedItemTags"
                  :items="tags"
                  :label="$t('components.vuematerialdashboard.core.appbar.tags')"
                  item-text="Name"
                  item-value="Id"
                  return-object
                  multiple
                ></v-autocomplete>
                <trans-multi-select2
                v-if="
                    editedItemRoles.filter(
                      (ur) =>
                        ur.Name === 'Employer Plan Admin' ||
                        ur.Name === 'Broker Plan Admin' ||
                        ur.Name === 'Broker Plan Manager' ||
                        ur.Name === 'Documents Management Admin' ||
                        ur.Name === 'Employer Members Viewer' ||
                        ur.Name === 'Employer Billing Viewer' ||
                        ur.Name === 'Employer Premiums Viewer' ||
                    ur.Name === 'Member Portal Admin' ||
                    ur.Name === 'Member Portal Users Admin'
                    ).length > 0
                  "
                  v-model="editedItemPlans"
                  :items="plans"
                  :label="$t('globals.plans')"
                  :rules="plansRules"
                  field="Name"
                  itemValue="Id"
                  :canSelectAll="true"
                  class="required"
                  validate-on-blur
                ></trans-multi-select2>
                <trans-multi-select2
                  v-if="
                    editedItemRoles.filter(
                      (ur) =>
                        ur.Name === 'Employer Plan Admin' ||
                        ur.Name === 'Employer Members Viewer' ||
                        ur.Name === 'Employer Billing Viewer' ||
                        ur.Name === 'Employer Premiums Viewer'
                    ).length > 0
                  "
                  v-model="editedItemEmployers"
                  :items="assignableEmployers"
                  :label="$t('globals.employers')"
                  field="Name"
                  itemValue="Id"
                  validate-on-blur
                  :rules="[$rules.atLeastOne]"
                ></trans-multi-select2>
                <trans-multi-select2
                  v-if="
                    editedItemRoles.filter(
                      (ur) =>
                        ur.Name === 'Employer Plan Admin' ||
                        ur.Name === 'Employer Members Viewer' ||
                        ur.Name === 'Employer Billing Viewer' ||
                        ur.Name === 'Employer Premiums Viewer'
                    ).length > 0
                  "
                  v-model="editedItemStores"
                  :items="assignableStores"
                  :label="$t('globals.stores')"
                  field="Name"
                  itemValue="Id"
                  validate-on-blur
                ></trans-multi-select2>
                <v-checkbox
                  v-model="token.IsActive"
                  :label="$t('globals.active')"
                ></v-checkbox>
              </v-form>
            </v-flex>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="close()">{{ $t("globals.cancel") }}</v-btn>
          <v-btn
            :disabled="!tokenvalid"
            color="primary"
            @click="createToken"
            :loading="saving"
          >
            {{ $t("views.users.create_token") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      v-model="assignRolesDialog"
      scrollable
      persistent
      max-width="500px"
    >
      <material-card
        :title="
          editedItem
            ? $t('views.users.assign_roles_{0}', [editedItem.Email])
            : $t('views.users.assign_roles')
        "
        :color="$vuetify.theme.themes.light.primary"
        icon="group_add"
      >
        <v-card-text>
          <v-container fluid fill-height>
            <v-flex md12>
              <v-form ref="roleform" v-model="rolevalid">
                <v-autocomplete
                  v-model="editedItemRoles"
                  :items="roles"
                  :label="$t('views.users.roles')"
                  item-text="Name"
                  item-value="Id"
                  return-object
                  multiple
                  :rules="[$rules.atLeastOne]"
                ></v-autocomplete>
                <v-autocomplete
                  v-if="
                    editedItemRoles.filter(
                      (ur) =>
                        ur.Name === 'Employer Plan Admin' ||
                        ur.Name === 'Broker Plan Admin' ||
                        ur.Name === 'Broker Plan Manager' ||
                        ur.Name === 'Documents Management Admin' ||
                        ur.Name === 'Employer Members Viewer' ||
                        ur.Name === 'Employer Billing Viewer' ||
                        ur.Name === 'Employer Premiums Viewer' ||
                    ur.Name === 'Member Portal Admin' ||
                    ur.Name === 'Member Portal Users Admin'
                    ).length > 0
                  "
                  v-model="editedItemTags"
                  :items="tags"
                  :label="$t('components.vuematerialdashboard.core.appbar.tags')"
                  item-text="Name"
                  item-value="Id"
                  return-object
                  multiple
                ></v-autocomplete>
                <trans-multi-select2
                v-if="
                    editedItemRoles.filter(
                      (ur) =>
                        ur.Name === 'Employer Plan Admin' ||
                        ur.Name === 'Broker Plan Admin' ||
                        ur.Name === 'Broker Plan Manager' ||
                        ur.Name === 'Documents Management Admin' ||
                        ur.Name === 'Employer Members Viewer' ||
                        ur.Name === 'Employer Billing Viewer' ||
                        ur.Name === 'Employer Premiums Viewer' ||
                    ur.Name === 'Member Portal Admin' ||
                    ur.Name === 'Member Portal Users Admin'
                    ).length > 0
                  "
                  v-model="editedItemPlans"
                  :items="plans"
                  :label="$t('globals.plans')"
                  :rules="[$rules.atLeastOne]"
                  field="Name"
                  itemValue="Id"
                  :canSelectAll="true"
                  class="required"
                  validate-on-blur
                ></trans-multi-select2>
                <trans-multi-select2
                  v-if="
                    editedItemRoles.filter(
                      (ur) =>
                        ur.Name === 'Employer Plan Admin' ||
                        ur.Name === 'Employer Members Viewer' ||
                        ur.Name === 'Employer Billing Viewer' ||
                        ur.Name === 'Employer Premiums Viewer'
                    ).length > 0
                  "
                  v-model="editedItemEmployers"
                  :items="assignableEmployers"
                  :label="$t('globals.employers')"
                  field="Name"
                  itemValue="Id"
                  validate-on-blur
                  :rules="[$rules.atLeastOne]"
                ></trans-multi-select2>
                <trans-multi-select2
                  v-if="
                    editedItemRoles.filter(
                      (ur) =>
                        ur.Name === 'Employer Plan Admin' ||
                        ur.Name === 'Employer Members Viewer' ||
                        ur.Name === 'Employer Billing Viewer' ||
                        ur.Name === 'Employer Premiums Viewer'
                    ).length > 0
                  "
                  v-model="editedItemStores"
                  :items="assignableStores"
                  :label="$t('globals.stores')"
                  field="Name"
                  itemValue="Id"
                  validate-on-blur
                ></trans-multi-select2>
              </v-form>
            </v-flex>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="close">{{ $t("globals.cancel") }}</v-btn>
          <v-btn
            :disabled="!rolevalid"
            color="primary"
            :loading="saving"
            @click="saveRole"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      v-model="assignPlansDialog"
      scrollable
      persistent
      max-width="500px"
    >
      <material-card
        :title="
          editedItem
            ? $t('views.users.assign_plans_{0}', [editedItem.Email])
            : $t('views.users.assign_plans')
        "
        :color="$vuetify.theme.themes.light.primary"
        icon="assignment"
      >
        <v-card-text>
          <v-container fluid fill-height>
            <v-flex md12>
              <v-form ref="planform" v-model="plansvalid">
                <v-autocomplete
                  v-model="editedItemTags"
                  :items="tags"
                  :label="$t('components.vuematerialdashboard.core.appbar.tags')"
                  item-text="Name"
                  item-value="Id"
                  return-object
                  multiple
                ></v-autocomplete>
                <trans-multi-select2
                  v-model="editedItemPlans"
                  :items="plans"
                  :label="$t('globals.plans')"
                  :rules="[$rules.atLeastOne]"
                  field="Name"
                  itemValue="Id"
                  :canSelectAll="true"
                  class="required"
                  validate-on-blur
                ></trans-multi-select2>
              </v-form>
            </v-flex>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="cancelAssignPlans()">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" @click="savePlans" :disabled="!plansvalid">
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      v-model="assignEmployersStoresDialog"
      scrollable
      persistent
      max-width="500px"
    >
      <material-card
        :title="
          editedItem
            ? $t('views.users.assign_employers_stores_{0}', [editedItem.Email])
            : $t('views.users.assign_employers_stores')
        "
        :color="$vuetify.theme.themes.light.primary"
        icon="assignment"
      >
        <v-card-text>
          <v-container fluid fill-height>
            <v-flex md12>
              <v-form ref="planform" v-model="employersstoresvalid">
<trans-multi-select2
                  v-model="editedItemEmployers"
                  :items="assignableEmployers"
                  :label="$t('globals.employers')"
                  field="Name"
                  itemValue="Id"
                  validate-on-blur
                  :rules="[$rules.atLeastOne]"
                ></trans-multi-select2>
                <trans-multi-select2
                  v-model="editedItemStores"
                  :items="assignableStores"
                  :label="$t('globals.stores')"
                  field="Name"
                  itemValue="Id"
                  validate-on-blur
                ></trans-multi-select2>
              </v-form>
            </v-flex>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="cancelAssignEmployersStores()">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            color="primary"
            :disabled="!employersstoresvalid"
            @click="saveEmployersStores"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog
      v-model="reportsDialog"
      scrollable
      persistent
      max-width="1500px"
    >
      <material-card
        v-if="reportsDialog"
        :title="$t('views.users.configure_reports_{0}', [editedItem.Email])"
        :color="$vuetify.theme.themes.light.primary"
        icon="assignment"
      >
        <v-card-text>
            <users-reports-configuration ref="reportsConfiguration" :user="editedItem" :roles="editedItemRoles.map(o=>o.Name)"
              @valid-changed="reportsValid = $event">
            </users-reports-configuration>
          <!-- <v-container fluid fill-height>
            <v-flex md12>
              <v-form ref="reportsForm" v-model="reportsValid">
                <v-autocomplete
                  :value.sync="selectedReports"
                  :items="reportOptions"
                  :label="$t('components.getreports.select_report')"
                  :rules="[$rules.atLeastOne]"
                  class="required"
                  :filter="filterFunc"
                  multiple
                >
                  <v-list-item slot="prepend-item" ripple @click="toggle">
                    <v-list-item-action>
                      <v-icon
                        :color="
                          selectedReports && selectedReports.length > 0 ? 'indigo darken-4' : ''
                        "
                        >{{ icon }}</v-icon
                      >
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title>{{
                        $t("components.trans-multi-select2.select_all")
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider slot="prepend-item" class="mt-2" />
                  <template v-slot:selection="data">
                    {{ $t("components.getreports." + data.item) }}
                  </template>
                  <template v-slot:item="data">
                    <v-list-item v-bind="data.attrs" v-on="data.on">
                      <v-list-item-action>
                        <v-checkbox v-model="data.attrs.inputValue"></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ $t("components.getreports." + data.item) }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-form>
            </v-flex>
          </v-container> -->
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="close()">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            color="primary"
            :disabled="!reportsValid"
            @click="saveReports"
          >
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-container
      fluid
      grid-list-md
      v-if="selectedBroker === null || selectedBroker === undefined"
    >
      <v-layout row justify-center>
        <v-flex xs12 sm6 md4 lg3>
          <v-card
            v-if="isLoggedIn && role.indexOf('Global Support Manager') > -1"
          >
            <v-card-text>
              <auto-select
                :items="brokers"
                :label="$t('views.tags.select_broker')"
                prepend-icon="supervised_user_circle"
                return-object
                :loading="brokersLoading"
                item-text="Name"
                item-value="Id"
                @change="
                  $router.push({
                    name: 'brokerUsers',
                    params: { brokerId: $event.Id },
                  })
                "
              />
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <material-card
      v-else
      :title="$t('components.vuematerialdashboard.core.appbar.users')"
      :color="$vuetify.theme.themes.light.secondary"
      icon="people"
    >
      <pbas-data-table
        ref="table"
        :exporters="$exporters"
        :dataProvider="provider"
        :floatActions="floatActions"
        :selectAll="true"
        :showSelect="true"
        :selectActions="selectActions"
        :rowActions="rowActions"
        fileNamePrefix="users"
        @itemsChanged="setData($event)"
        identifier="usersTable"
        @error="error = $event"
      ></pbas-data-table>
      <!--<data-table
        ref="table"
        :headers="headers"
        :title="tableTitle"
        tableKey="Id"
        :rowActions="rowActions"
        :floatActions="floatActions"
        :selectAll="true"
        :showSelect="true"
        :url="odataUrl"
        @odataItems="setData($event)"
        @customHeaders="saveHeaders($event)"
        :displayFunctions="displayFunctions"
        :columnsOptions="columnsOptions"
        :selectActions="selectActions"
        :provider="provider"
      ></data-table>-->

      <v-snackbar
        v-model="snackbar"
        :color="color"
        :multi-line="mode === 'multi-line'"
        :timeout="timeout"
        :vertical="mode === 'vertical'"
      >
        {{ $t(message) }}
        <v-btn dark text @click="snackbar = false">
          {{ $t("globals.close") }}
        </v-btn>
      </v-snackbar>
    </material-card>
    <error-handler :error="error"></error-handler>
  </div>
</template>

<script>
import jwt from "jsonwebtoken";
import { mapActions, mapGetters } from "vuex";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import getUserHeaders from "../headers/Users";
import ErrorHandler from "../components/ErrorHandler";
import AutoSelect from "../components/AutoSelect";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import MultiSelectAll from "../components/MultiSelectAll.vue";
import UsersReportsConfiguration from "../components/UsersReportsConfiguration.vue";
import TransMultiSelect2 from "../components/TransMultiSelect2.vue";
import { sortAlphanum } from "@/alphanumericSort"

export default {
  name: "users-table",
  components: {
    ErrorHandler,
    AutoSelect,
    NoAutocompleteTextfield,
    MultiSelectAll,
    UsersReportsConfiguration,
    TransMultiSelect2
  },
  data() {
    return {
      confirmEmail:null,
      rules:{
        confirmEmail: (v) =>
          !v || this.editedIndex > -1 || (this.editedIndex === -1 && this.editedItem.Email === this.confirmEmail) ||
          this.$t("validation.emails_must_match"),
        confirmTokenEmail: (v) =>
          !v || this.token.email === this.confirmEmail ||
          this.$t("validation.emails_must_match"),
      },
      reportsDialog: false,
      reportsValid: false,
      // selectedReports: [],
      reportOptions: ["Premiums", "Billing", "Remittances"],
      blockTagsUpdate: false,
      error: null,
      brokersLoading: true,
      provider: undefined,
      selectedBroker: null,
      confirmDeactivateDialog: false,
      confirmActivateDialog: false,
      emailErrorMessages: [],
      emailError: false,
      editedItemTags: [],
      editedItemPlans: [],
      editedItemEmployers: [],
      editedItemStores: [],
      columnsOptions: {},
      editedItemRoles: [],
      floatActions: [
        {
          name: "addUser",
          icon: "add",
          color: this.$vuetify.theme.themes.light.success,
          text: "globals.add_new",
          handler: () => this.editItem(this.defaultItem),
        },
        {
          name: "addToken",
          icon: "vpn_key",
          color: this.$vuetify.theme.themes.light.success,
          text: "views.users.token",
          handler: this.createWithToken,
          class: "register-with-token",
        },
      ],
      rowActions: [
        {
          name: "editItem",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => this.editItem(item),
        },
        {
          name: "deleteItem",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => {
            this.selectedItem = item;
            this.confirmDeleteDialog = true;
          },
        },
        {
          name: "resetPassword",
          icon: "clear",
          title: "components.membersmanagementtable.reset_password",
          handler: (item) => {
            this.selectedItem = item;
            this.confirmResetPasswordDialog = true;
          },
        },
        {
          name: "assignRoles",
          icon: "group_add",
          title: "views.users.assign_roles",
          handler: (item) => this.assignRoles(item),
        },
        {
          name: "assignPlans",
          icon: "assignment",
          title: "views.users.assign_plans",
          handler: (item) => this.assignPlans(item),
          visible: (item) => {
            let roles = [];
            item.Roles.forEach((itemRole) => {
              let commonRoles = this.roles.filter(
                (r) => r.Id === itemRole.RoleId
              );
              if (commonRoles.length > 0) roles.push(commonRoles[0]);
            });
            return (
              roles.filter(
                (ur) =>
                  ur.Name === "Employer Plan Admin" ||
                  ur.Name === "Broker Plan Admin" ||
                  ur.Name === "Broker Plan Manager" ||
                  ur.Name === "Documents Management Admin" ||
                  ur.Name === "Employer Members Viewer" ||
                  ur.Name === "Employer Billing Viewer" ||
                  ur.Name === "Employer Premiums Viewer" ||
                    ur.Name === 'Member Portal Admin' ||
                    ur.Name === 'Member Portal Users Admin'
              ).length > 0
            );
          },
        },
        {
          name: "assignEmployersStores",
          icon: "assignment",
          title: "views.users.assign_employers_stores",
          handler: (item) => this.assignEmployersStores(item),
          visible: (item) => {
            let roles = [];
            item.Roles.forEach((itemRole) => {
              let commonRoles = this.roles.filter(
                (r) => r.Id === itemRole.RoleId
              );
              if (commonRoles.length > 0) roles.push(commonRoles[0]);
            });
            return (
              roles.filter(
                (ur) =>
                  ur.Name === "Employer Plan Admin" ||
                  ur.Name === "Employer Members Viewer" ||
                  ur.Name === "Employer Billing Viewer" ||
                  ur.Name === "Employer Premiums Viewer"
              ).length > 0
            );
          },
        },
        {
          name: "deactivate",
          icon: "toggle_off",
          title: "globals.deactivate",
          handler: (item) => {
            this.selectedItem = item;
            this.confirmDeactivateDialog = true;
          },
          visible: (item) => item.IsActive === true,
        },
        {
          name: "activate",
          icon: "toggle_on",
          title: "globals.activate",
          handler: (item) => {
            this.selectedItem = item;
            this.confirmActivateDialog = true;
          },
          visible: (item) => item.IsActive === false,
        },
        {
          name: "reportsConfiguration",
          icon: "assignment",
          title: "views.users.configure_reports",
          handler: (item) => {
            if (item !== null && item !== undefined) {
              this.editedIndex = this.users.indexOf(item);
              this.editedItem = Object.assign({}, item);
              this.editedItem.Roles.forEach((itemRole) => {
                let commonRoles = this.roles.filter((r) => r.Id === itemRole.RoleId);
                if (commonRoles.length > 0) this.editedItemRoles.push(commonRoles[0]);
              });
              console.log(this.editedItem, this.editedItemRoles)
              // if (this.editedItem.ReportsConfiguration) {
              //   this.selectedReports = JSON.parse(
              //     JSON.stringify(this.editedItem.ReportsConfiguration)
              //   );
              // } else {
              //   this.selectedReports = [];
              // }
            } else {
              this.editedItem = null;
              // this.selectedReports = [];
            }
            this.reportsDialog = true;
          },
        },
      ],
      selectActions: [
        {
          name: "assignRoles",
          icon: "group_add",
          title: "views.users.assign_roles",
          handler: () => this.assignRoles(),
        },
        {
          name: "assignPlans",
          icon: "assignment",
          title: "views.users.assign_plans",
          handler: () => this.assignPlans(),
        },
        {
          name: "deactivate",
          icon: "toggle_off",
          title: "globals.deactivate",
          handler: () => {
            this.selectedItem = null;
            this.confirmDeactivateDialog = true;
          },
        },
        {
          name: "activate",
          icon: "toggle_on",
          title: "globals.activate",
          handler: () => {
            this.selectedItem = null;
            this.confirmActivateDialog = true;
          },
        },
      ],
      tableTitle: "Users",
      tokenvalid: true,
      token: {
        IsActive: true
      },
      createTokenDialog: false,
      roles: [],
      tags: [],
      confirmResetPasswordDialog: false,
      snackbar: false,
      color: "",
      mode: "",
      timeout: 4000,
      message: "",
      confirmDeleteDialog: false,
      selectedItem: null,
      brokers: [],
      plansRules: [
        (v) =>
          this.plansValid(v) ||
          this.$t("validation.at_least_one_plan_is_required"),
      ],
      plansvalid: true,
      employersstoresvalid: true,
      valid: true,
      rolevalid: true,
      broker: null,
      plans: [],
      assignableEmployers: [],
      assignableStores: [],
      editDialog: false,
      assignRolesDialog: false,
      assignPlansDialog: false,
      assignEmployersStoresDialog: false,
      users: [],
      headers: null,
      saving: false,
      editedIndex: -1,
      editedItem: {
        FirstName: "",
        LastName: "",
        Email: "",
        Roles: [],
        Tags: [],
        Plans: [],
        Broker: null,
      },
      defaultItem: {
        FirstName: "",
        LastName: "",
        Email: "",
        Roles: [],
        Tags: [],
        Plans: [],
        Employers: [],
        Stores: [],
        Broker: null,
        IsActive: true
      },
      loading: false
    };
  },
  computed: {
    ...mapGetters("common", ["language"]),
    // allItems() {
    //   return (
    //     this.selectedReports && this.selectedReports.length === this.reportOptions.length
    //   );
    // },
    // someItems() {
    //   return (
    //     this.selectedReports && this.selectedReports.length > 0 && !this.allItems
    //   );
    // },
    // icon() {
    //   if (this.allItems) return "mdi-close-box";
    //   if (this.someItems) return "mdi-minus-box";
    //   return "mdi-checkbox-blank-outline";
    // },
    odataUrl() {
      return "brokers/" + this.selectedBroker.Id + "/users";
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("views.users.create_new_user")
        : this.$t("views.users.edit_user_{0}", [this.editedItem.Email]);
    },
    formIcon() {
      return this.editedIndex === -1 ? "add" : "edit";
    },
    formColor() {
      return this.editedIndex === -1 ? this.$vuetify.theme.themes.light.success : this.$vuetify.theme.themes.light.primary;
    },
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", ["settings"]),
  },
  watch: {
    "editedItem.Broker": {
      handler(v) {
        if (v) {
          this.editedItem.BrokerId = this.editedItem.Broker.Id;
        } else {
          if (this.editedItem) this.editedItem.BrokerId = null;
        }
      },
    },
    "token.email": {
      handler() {
        this.emailErrorMessages = [];
        this.emailError = false;
        if (this.$refs.tokenform) this.$refs.tokenform.validate();
      },
    },
    confirmEmail: {
      handler() {
        this.emailErrorMessages = [];
        this.emailError = false;
        if (this.$refs.tokenform) this.$refs.tokenform.validate();
        if (this.$refs.form) this.$refs.form.validate();
      },
    },
    "editedItem.Email": {
      handler() {
        this.emailErrorMessages = [];
        this.emailError = false;
        if (this.$refs.form) this.$refs.form.validate();
      },
    },
    editedItemTags: {
      handler(v, old) {
        if (this.blockTagsUpdate === true) {
          this.blockTagsUpdate = false;
          return;
        }
        let tagPlans = this.plansFromTags();
        if (v.length > old.length) {
          tagPlans.forEach((p) => {
            var inEditedItemPlans = this.editedItemPlans.filter(
              (o) => o.Id == p.Id
            );
            if (inEditedItemPlans.length === 0) {
              this.editedItemPlans.push(p);
            }
          });
        } else if (v.length < old.length) {
          const removed = old.filter(
            (o) => v.filter((t) => t.Id === o.Id).length === 0
          );
          let toRemove = [];
          for (const tag of removed) {
            for (const plan of this.editedItemPlans) {
              if (tag.Plans.filter((o) => o.Id === plan.Id).length > 0) {
                toRemove.push(plan);
              }
            }
          }
          this.blockTagsUpdate = true;
          this.editedItemPlans = this.editedItemPlans.filter(
            (o) => toRemove.filter((p) => p.Id === o.Id).length === 0
          ).sort((a, b) => {
            const translatedA =  a.Translations.filter(
                (o) => o.LanguageCode === this.language.language
              )[0].Name;
            const translatedB = b.Translations.filter(
                (o) => o.LanguageCode === this.language.language
              )[0].Name;
              console.log(translatedA, translatedB);
            return sortAlphanum(translatedA, translatedB);
          });
        }
      },
    },
    editedItemPlans: {
      async handler(v) {
        // console.log("ASDF");
        console.log(this.editedItemPlans);
        /*let toRemove = [];
        for (const tag of this.editedItemTags) {
          for (const tagPlan of tag.Plans) {
            if (v.filter(o => o.Id === tagPlan.Id).length === 0) {
              toRemove.push(tag);
              break;
            }
          }
        }
        let afterRemoval = this.editedItemTags.filter(
          o => toRemove.filter(t => t.Id === o.Id).length === 0
        );*/

        let all = v.map((o) => o.Tags).flat(1);
        let tags = [];
        for (const tag of all) {
          let missing = false;
          if (tag.Plans) {
            for (const tagPlan of tag.Plans) {
              if (v.filter((o) => o.Id === tagPlan.Id).length === 0) {
                missing = true;
              }
            }
          } else {
            missing = true;
          }
          if (!missing) {
            if (tags.filter((o) => o.Id === tag.Id).length === 0) {
              tags.push(tag);
            }
          }
        }
        this.blockTagsUpdate = true;
        this.editedItemTags = tags.sort((a, b) => (a.Name < b.Name ? -1 : 1));
        await this.fetchAssignableEmployersStores(this.editedItemPlans);
      },
    },
    selectedBroker: {
      async handler(v) {
        if (v) {
          try {
            this.loading = true;
            this.tags = (await this.getTags(this.selectedBroker.Id)).data.value;
            this.plans = (await this.getOrganizationPlans(
              this.selectedBroker.Id
            )).data.value;
            this.provider = new PbasOData(
              this.$axiosHttp,
              this.odataUrl,
              this.headers
            );
          } catch (error) {
            this.error = error;
          } finally {
            this.loading = false;
          }
        }
      },
    },
  },
  async mounted() {
    try {
      this.brokers = (await this.getOrganizations()).data.value;
      var usr = await this.getUser();
      if (this.role.indexOf("Global Support Manager") > -1) {
        this.selectedBroker = null;
      } else if (this.role.indexOf("Broker Support Admin") > -1) {
        this.selectedBroker = this.brokers.filter(
          (o) => o.Id === usr.profile.brokerid
        )[0];
      }
      this.roles = (await this.getRoles()).data;
      this.headers = getUserHeaders(this.roles);
      this.columnsOptions["brokers"] = this.brokers;

      if (this.$route.params.brokerId) {
        this.selectedBroker = this.brokers.filter(
          (o) => o.Id === this.$route.params.brokerId
        )[0];
      }

      if (this.brokers.length === 1) {
        // this.broker = this.brokers[0];
        this.$router.push({
          name: "brokerUsers",
          params: { brokerId: this.brokers[0].Id },
        });
      }
    } catch (error) {
      this.error = error;
    } finally {
      this.brokersLoading = false;
    }
  },
  methods: {
    /*$t(args) {
        console.log(this.messages, args)
        if (Object.keys(this.messages).indexOf(args) < 0) {
            this.messages[args]="TRANSLATION REQUIRED"
        }
        return "TRANSLATION REQUIRED";
    },*/
    ...mapActions("auth", ["getRoles", "getUser"]),
    ...mapActions("applicationUsers", [
      "getOrganizations",
      "getTags",
      "registerWithToken",
      "deleteUser",
      "newUser",
      "updateUser",
      "getUsers",
      "updateUsersPlans",
      "updateUsersEmployersStores",
      "updateUsersRoles",
      "updateUsersActive",
      "setResetPassword",
      "getOrganizationPlans"
    ]),
    ...mapActions("applicationUsers", { getUserById: "getUser" }),
    ...mapActions("transactions", ["saveUserReportsConfiguration"]),
    // toggle() {
    //   this.$nextTick(() => {
    //     if (this.allItems) {
    //       this.selectedReports = [];
    //     } else {
    //       this.selectedReports = this.reportOptions.slice()
    //     }
    //   });
    // },
    async saveReports() {
      this.saving = true;
      let payload = [];
      let reportsConfigurations = JSON.parse(JSON.stringify(this.$refs.reportsConfiguration.reportsConfigurations));
      for (let rc of reportsConfigurations) {
        console.log(rc);
        delete rc.Plan;
        delete rc.ReportParameters.CoverageGroups;
        delete rc.ReportParameters.Employers;
        delete rc.ReportParameters.InsuranceCarriers;
        delete rc.ReportParameters.Stores;
        delete rc.ReportParameters.TrustFunds;
        delete rc.ReportParameters.Plan;
        rc.ReportParameters.PlanId = rc.PlanId;
        delete rc.ReportParameters.Identifier;
        rc.UserId = this.editedItem.Id
        payload.push(rc);
      }
      try {
        await this.saveUserReportsConfiguration({
          userId: this.editedItem.Id,
          payload: payload
        });
        this.reportsDialog = false;
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    filterFunc(item, search) {
      console.log(item);
      return this.$t('components.getreports.'+ item).toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    async fetchAssignableEmployersStores(selectedPlans) {
      var selectedPlanIds = selectedPlans.map((s) => s.Id);
      var plans = (await this.getOrganizationPlans(this.selectedBroker.Id)).data
        .value;
      var selectedPlansWithEmployersStores = plans.filter(
        (p) => selectedPlanIds.indexOf(p.Id) !== -1
      );
      this.assignableEmployers = selectedPlansWithEmployersStores
        .map((p) => p.Employers)
        .flat();
      this.assignableStores = selectedPlansWithEmployersStores
        .map((p) => p.Stores)
        .flat();
    },
    plansValid(v) {
      if (this.editedItemRoles) {
        if (
          this.editedItemRoles.filter(
            (ur) =>
              ur.Name === "Broker Plan Manager" ||
              ur.Name === "Broker Plan Admin" ||
              ur.Name === "Employer Plan Admin" ||
              ur.Name === "Employer Premiums Viewer" ||
              ur.Name === "Employer Billing Viewer" ||
              ur.Name === "Employer Members Viewer"
          ).length > 0
        ) {
          return !!v && v.length > 0;
        }
        return true;
      }
      return true;
    },
    async deactivate() {
      this.saving = true;
      if (this.selectedItem !== null && this.selectedItem !== undefined) {
        try {
          let newActive = {
            UserIds: [this.selectedItem.Id],
            Active: false,
          };
          await this.updateUsersActive({
            broker: this.selectedBroker.Id,
            payload: newActive,
          });

          this.$refs.table.getDataAsync();
          this.color = "success";
          this.message = "globals.success";
          this.snackbar = true;
          this.confirmDeactivateDialog = false;
        } catch (error) {
          this.error = error;
        }
      } else {
        try {
          let newActive = {
            UserIds: this.$refs.table.selected.map((o) => o.Id),
            Active: false,
          };
          await this.updateUsersActive({
            broker: this.selectedBroker.Id,
            payload: newActive,
          });
          this.$refs.table.getDataAsync();
          this.color = "success";
          this.message = "globals.success";
          this.snackbar = true;
          this.confirmDeactivateDialog = false;
        } catch (error) {
          this.error = error;
        }
      }
      this.saving = false;
    },
    async activate() {
      this.saving = true;
      if (this.selectedItem !== null && this.selectedItem !== undefined) {
        try {
          let newActive = {
            UserIds: [this.selectedItem.Id],
            Active: true,
          };
          await this.updateUsersActive({
            broker: this.selectedBroker.Id,
            payload: newActive,
          });

          this.$refs.table.getDataAsync();
          this.confirmActivateDialog = false;
          this.color = "success";
          this.message = "globals.success";
          this.snackbar = true;
        } catch (error) {
          this.error = error;
        }
      } else {
        try {
          let newActive = {
            UserIds: this.$refs.table.selected.map((o) => o.Id),
            Active: true,
          };
          await this.updateUsersActive({
            broker: this.selectedBroker.Id,
            payload: newActive,
          });
          this.$refs.table.getDataAsync();
          this.confirmActivateDialog = false;
          this.color = "success";
          this.message = "globals.success";
          this.snackbar = true;
        } catch (error) {
          this.error = error;
        }
      }
      this.saving = false;
    },
    async uniqueEmail(email) {
      try {
        let users = (await this.getUsers()).data.value;
        if (users.filter((o) => o.Email === email).length > 0) return false;
        return true;
      } catch (error) {
        this.error = error;
        return false;
      }
    },
    saveHeaders(headerscopy) {
      this.headers = JSON.parse(JSON.stringify(headerscopy));
    },
    setData(items) {
      this.users = items;
    },
    createWithToken() {
      this.token.broker = this.selectedBroker;
      this.createTokenDialog = true;
    },
    async createToken() {
      this.saving = true;
      /*let isUnique = await this.uniqueEmail(this.token.email);
      if (!isUnique) {
        this.emailErrorMessages = ["Email is already registered"];
        this.emailError = true;
        this.saving = false;
        return;
      }*/
      //console.log(this.token, this.settings.RegistrationTokenSecret)
      this.token.roles = JSON.parse(JSON.stringify(this.editedItemRoles));
      delete this.token.roles.Users;
      this.token.plans = this.editedItemPlans.map((o) => {
        if (o.Tags) {
          for (let tag of o.Tags) {
            delete tag.Plans;
          }
        }
        return o;
      });
      this.token.employers = JSON.parse(
        JSON.stringify(this.editedItemEmployers)
      );
      this.token.stores = JSON.parse(JSON.stringify(this.editedItemStores));
      var token = jwt.sign(this.token, this.settings.RegistrationTokenSecret, {
        expiresIn: this.settings.TokenExpirationTime,
      });
      //console.log("token: ", token)

      try {
        await this.registerWithToken({
          broker: this.selectedBroker.Id,
          payload: {
            Email: this.token.email,
            Token: window.location.origin + "/#/register-with-token/" + token,
          },
        });
        this.close();
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.assignPlansDialog = false;
        this.assignEmployersStoresDialog = false;
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async editItem(item) {
      this.editedIndex = this.users.indexOf(item);
      try {
        this.editedItem =
          this.editedIndex > -1
            ? (await this.getUserById({
                broker: this.selectedBroker.Id,
                user: item.Id,
              })).data
            : JSON.parse(JSON.stringify(item));
        this.editedItemRoles = [];
        this.editedItem.Roles.forEach((itemRole) => {
          let commonRoles = this.roles.filter((r) => r.Id === itemRole.RoleId);
          if (commonRoles.length > 0) this.editedItemRoles.push(commonRoles[0]);
        });
        this.editedItemTags = [];
        let all = item.Plans.map((o) => o.Tags).flat(1);
        //console.log(all)
        this.editedItemTags = [];
        for (const tag of all) {
          let missing = false;
          if (tag.Plans) {
            for (const tagPlan of tag.Plans) {
              if (item.Plans.filter((o) => o.Id === tagPlan.Id).length === 0) {
                missing = true;
              }
            }
          } else {
            missing = true;
          }
          if (!missing) {
            if (
              this.editedItemTags.filter((o) => o.Id === tag.Id).length === 0
            ) {
              this.editedItemTags.push(tag);
            }
          }
        }
        //console.log(this.editedItem, this.editedItemTags);
        this.blockTagsUpdate = true;
        this.editedItemTags = this.editedItemTags.sort((a, b) =>
          a.Name < b.Name ? -1 : 1
        );
        this.editedItemPlans = JSON.parse(
          JSON.stringify(this.editedItem.Plans)
        ).sort((a, b) => {
          if (a && a.Translations && b && b.Translations) {
            const translatedA =  a.Translations.filter(
                (o) => o.LanguageCode === this.language.language
              )[0].Name;
            const translatedB = b.Translations.filter(
                (o) => o.LanguageCode === this.language.language
              )[0].Name;
              // console.log(translatedA, translatedB);
            return sortAlphanum(translatedA, translatedB);
          }
          return 0;
          });

        this.editedItemEmployers = JSON.parse(
          JSON.stringify(this.editedItem.Employers)
        );
        this.editedItemStores = JSON.parse(
          JSON.stringify(this.editedItem.Stores)
        );
        await this.fetchAssignableEmployersStores(this.editedItemPlans);
        if (this.editedIndex === -1)
          this.editedItem.Broker = this.selectedBroker;
        this.editDialog = true;
        this.$nextTick(() => {
          this.$refs.form.validate();
          this.$refs.form.resetValidation();
        });
        console.log(this.editedItemEmployers, this.editedItemStores, this.assignableEmployers, this.assignableStores);
      } catch (error) {
        this.error = error;
      }

      /*const t = item.Plans.filter(p => p.Tags.length > 0)
        .map(p => p.Tags)
        .reduce((a, b) => a.concat(b), []);
      console.log(t);
      let exists = false;
      for (const tag of t) {
        exists = false;
        for (const tag2 of this.editedItemTags) {
          if (tag.Id === tag2.Id) {
            exists = true;
            break;
          }
        }
        if (!exists) {
          this.editedItemTags.push(this.tags.filter(o=>o.Id === tag.Id)[0]);
        }
      }*/
    },
    async deleteItem() {
      try {
        await this.deleteUser({
          broker: this.selectedBroker.Id,
          id: this.selectedItem.Id,
        });
        await this.$refs.table.getDataAsync();
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.confirmDeleteDialog = false;
      } catch (error) {
        this.error = error;
      }
    },
    async resetPassword() {
      this.saving = true;
      try {
        let token = jwt.sign(
          { broker: this.selectedBroker.Id, id: this.selectedItem.Id },
          this.settings.RegistrationTokenSecret,
          { expiresIn: this.settings.TokenExpirationTime }
        );
        await this.setResetPassword({
          broker: this.selectedBroker.Id,
          payload: {
            Id: this.selectedItem.Id,
            Token: window.location.origin + "/#/reset-password/" + token,
          },
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.confirmResetPasswordDialog = false;
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    close() {
      this.confirmEmail = null;
      this.reportsDialog = false;
      this.createTokenDialog = false;
      this.editDialog = false;
      this.assignRolesDialog = false;
      this.assignPlansDialog = false;
      this.assignEmployersStoresDialog = false;
      if (this.$refs.form) this.$refs.form.resetValidation();
      if (this.$refs.roleform) this.$refs.roleform.resetValidation();
      if (this.$refs.planform) this.$refs.planform.resetValidation();
      this.token = {
        IsActive: true
      };
      if (this.$refs.tokenform) this.$refs.tokenform.resetValidation();
      this.saving = false;
      this.$nextTick(() => {
        this.editedItemTags = [];
        this.editedItemPlans = [];
        this.editedItemRoles = [];
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async save() {
      if (
        this.editedItemRoles.filter(
          (ur) =>
            ur.Name === "Employer Plan Admin" ||
            ur.Name === "Broker Plan Admin" ||
            ur.Name === "Broker Plan Manager" ||
            ur.Name === "Documents Management Admin" ||
            ur.Name === "Employer Members Viewer" ||
            ur.Name === "Employer Billing Viewer" ||
            ur.Name === "Employer Premiums Viewer" ||
                    ur.Name === 'Member Portal Admin' ||
                    ur.Name === 'Member Portal Users Admin'
        ).length > 0
      ) {
        this.editedItem.Plans = this.editedItemPlans.map((o) => {
          if (o.Tags) {
            for (let tag of o.Tags) {
              delete tag.Plans;
            }
          }
          return o;
        });
      } else {
        this.editedItem.Plans = [];
      }
      if (
        this.editedItemRoles.filter(
          (ur) =>
            ur.Name === "Employer Plan Admin" ||
            ur.Name === "Employer Members Viewer" ||
            ur.Name === "Employer Billing Viewer" ||
            ur.Name === "Employer Premiums Viewer"
        ).length > 0
      ) {
        this.editedItem.Employers = JSON.parse(
          JSON.stringify(this.editedItemEmployers)
        );
        this.editedItem.Stores = JSON.parse(
          JSON.stringify(this.editedItemStores)
        );
      } else {
        this.editedItem.Employers = [];
        this.editedItem.Stores = [];
      }

      this.saving = true;
      if (this.editedIndex > -1) {
        try {
          this.editedItem.Roles = [];
          this.editedItemRoles.forEach((role) => {
            this.editedItem.Roles.push({
              UserId: this.editedItem.Id,
              RoleId: role.Id,
            });
          });

          await this.updateUser({
            broker: this.selectedBroker.Id,
            user: this.editedItem,
          });
          this.color = "success";
          this.message = "globals.success";
          this.snackbar = true;
          this.close();
          this.$refs.table.getDataAsync();
        } catch (error) {
          this.error = error;
        }
      } else {
        //this.editedItem.brokerUid = this.editedItem.broker.id
        /*var options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute:'2-digit', second:'2-digit' };
          this.editedItem.registrationDate = new Date().toLocaleString("en-US", options)*/
        try {
          this.editedItem.Roles = [];
          this.editedItemRoles.forEach((role) => {
            this.editedItem.Roles.push({
              RoleId: role.Id,
            });
          });
          this.editedItem.UserName = this.editedItem.Email;
          this.editedItem.IsConfirmed = false;
          var token = jwt.sign(
            { email: this.editedItem.Email },
            this.settings.RegistrationTokenSecret,
            { expiresIn: this.settings.TokenExpirationTime }
          );
          this.editedItem.ResetLink =
            window.location.origin + "/#/first-login/" + token + "/";
          await this.newUser({
            broker: this.selectedBroker.Id,
            user: this.editedItem,
          });
          this.close();
          this.$refs.table.getDataAsync();
          this.color = "success";
          this.message = "globals.success";
          this.snackbar = true;
        } catch (error) {
          this.error = error;
        }
      }
      this.saving = false;
    },
    async saveRole() {
      this.saving = true;
      if (
        this.editedItemRoles.filter(
          (ur) =>
            ur.Name === "Employer Plan Admin" ||
            ur.Name === "Employer Members Viewer" ||
            ur.Name === "Employer Billing Viewer" ||
            ur.Name === "Employer Premiums Viewer"
        ).length === 0
      ) {
        this.editedItemEmployers = [];
        this.editedItemStores = [];
      }
      if (
        this.editedItemRoles.filter(
          (ur) =>
            ur.Name === "Employer Plan Admin" ||
            ur.Name === "Broker Plan Admin" ||
            ur.Name === "Broker Plan Manager" ||
            ur.Name === "Documents Management Admin" ||
            ur.Name === "Employer Members Viewer" ||
            ur.Name === "Employer Billing Viewer" ||
            ur.Name === "Employer Premiums Viewer" ||
                    ur.Name === 'Member Portal Admin' ||
                    ur.Name === 'Member Portal Users Admin'
        ).length === 0
      ) {
        this.editedItemPlans = [];
      } 
      let newRoles = {};
      if (this.editedIndex > -1) {
        newRoles = {
          UserIds: [this.editedItem.Id],
          RoleIds: this.editedItemRoles.map((o) => o.Id),
          EmployerIds: this.editedItemEmployers.map((o) => o.Id),
          StoreIds: this.editedItemStores.map((o) => o.Id),
          PlanIds: this.editedItemPlans.map((o) => o.Id),
        };
      } else {
        newRoles = {
          UserIds: this.$refs.table.selected.map((o) => o.Id),
          RoleIds: this.editedItemRoles.map((o) => o.Id),
          EmployerIds: this.editedItemEmployers.map((o) => o.Id),
          StoreIds: this.editedItemStores.map((o) => o.Id),
          PlanIds: this.editedItemPlans.map((o) => o.Id),
        };
      }
      try {
        await this.updateUsersRoles({
          broker: this.selectedBroker.Id,
          payload: newRoles,
        });
        this.close();
        this.saving = false;
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        await this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      }
    },
    async assignRoles(item) {
      this.editedItemRoles = [];
      if (item !== null && item !== undefined) {
        this.editedIndex = this.users.indexOf(item);
        this.editedItem = Object.assign({}, item);
        //console.log("add role: ", item, this.editedItem.roles)
        //this.editedItem.rolescopy = JSON.parse(JSON.stringify(this.editedItem.roles))
        this.editedItem.Roles.forEach((itemRole) => {
          let commonRoles = this.roles.filter((r) => r.Id === itemRole.RoleId);
          if (commonRoles.length > 0) this.editedItemRoles.push(commonRoles[0]);
        });
        await this.fetchAssignableEmployersStores(this.editedItem.Plans);
        this.editedItemEmployers = JSON.parse(
          JSON.stringify(this.editedItem.Employers)
        );
        this.editedItemStores = JSON.parse(
          JSON.stringify(this.editedItem.Stores)
        );
        this.editedItemPlans = JSON.parse(
          JSON.stringify(this.editedItem.Plans)
        ).sort((a, b) => {
            const translatedA =  a.Translations.filter(
                (o) => o.LanguageCode === this.language.language
              )[0].Name;
            const translatedB = b.Translations.filter(
                (o) => o.LanguageCode === this.language.language
              )[0].Name;
              console.log(translatedA, translatedB);
            return sortAlphanum(translatedA, translatedB);
          });
      } else {
        this.editedItem = null;
      }
      this.assignRolesDialog = true;
    },
    assignPlans(item) {
      if (item !== null && item !== undefined) {
        this.editedIndex = this.users.indexOf(item);
        this.editedItem = Object.assign({}, item);
        this.editedItemPlans = JSON.parse(
          JSON.stringify(this.editedItem.Plans)
        ).sort((a, b) => {
            const translatedA =  a.Translations.filter(
                (o) => o.LanguageCode === this.language.language
              )[0].Name;
            const translatedB = b.Translations.filter(
                (o) => o.LanguageCode === this.language.language
              )[0].Name;
              console.log(translatedA, translatedB);
            return sortAlphanum(translatedA, translatedB);
          });
      } else {
        this.editedItem = null;
      }
      this.assignPlansDialog = true;
    },
    async assignEmployersStores(item) {
      if (item !== null && item !== undefined) {
        this.editedIndex = this.users.indexOf(item);
        this.editedItem = Object.assign({}, item);
        await this.fetchAssignableEmployersStores(this.editedItem.Plans);
        this.editedItemEmployers = JSON.parse(
          JSON.stringify(this.editedItem.Employers)
        );
        this.editedItemStores = JSON.parse(
          JSON.stringify(this.editedItem.Stores)
        );
      } else {
        this.editedItem = null;
      }
      this.assignEmployersStoresDialog = true;
    },
    async savePlans() {
      let newPlans = {};
      if (this.editedIndex > -1) {
        newPlans = {
          UserIds: [this.editedItem.Id],
          PlanIds: this.editedItemPlans.map((o) => o.Id),
        };
      } else {
        newPlans = {
          UserIds: this.$refs.table.selected.map((o) => o.Id),
          PlanIds: this.editedItemPlans.map((o) => o.Id),
        };
      }
      try {
        await this.updateUsersPlans({
          broker: this.selectedBroker.Id,
          payload: newPlans,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.assignPlansDialog = false;
        this.assignEmployersStoresDialog = false;
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      }
    },
    async saveEmployersStores() {
      let payload = {};
      if (this.editedIndex > -1) {
        payload = {
          UserIds: [this.editedItem.Id],
          EmployerIds: this.editedItemEmployers.map((o) => o.Id),
          StoreIds: this.editedItemStores.map((o) => o.Id),
        };
      } else {
        payload = {
          UserIds: this.$refs.table.selected.map((o) => o.Id),
          EmployerIds: this.editedItemEmployers.map((o) => o.Id),
          StoreIds: this.editedItemStores.map((o) => o.Id),
        };
      }
      try {
        await this.updateUsersEmployersStores({
          broker: this.selectedBroker.Id,
          payload: payload,
        });
        this.color = "success";
        this.message = "globals.success";
        this.snackbar = true;
        this.assignEmployersStoresDialog = false;
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      }
    },
    plansFromTags() {
      let plans = [];
      this.editedItemTags.forEach((tag) => {
        //console.log("pft: tag", tag);
        if (tag.Plans) {
          tag.Plans.forEach((tagPlan) => {
            //console.log("pft: plan", tag);
            const plan = this.plans.filter((o) => o.Id === tagPlan.Id)[0];
            if (plans.filter((p) => p.Id === plan.Id).length === 0)
              plans.push(plan);
          });
        }
      });
      return plans;
    },
    cancelAssignPlans() {
      this.close();
    },
    cancelAssignEmployersStores() {
      this.close();
    },
  },
};
</script>
